import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { BlockButtons, Button, Tooltip, TooltipContainer } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SectionActions = ({
  isValidSection = true,
  onDelete,
  onDone,
  onCancel
}) => {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs(BlockButtons, {
    children: [/*#__PURE__*/_jsx(Button, {
      type: "button",
      kind: "outline",
      small: true,
      onClick: onCancel,
      children: __('Cancel')
    }), /*#__PURE__*/_jsx(TooltipContainer, {
      id: "section-webforward-done-tooltip",
      enabled: !isValidSection,
      renderReference: getReferenceProps => /*#__PURE__*/_jsx(Button, {
        ...getReferenceProps(),
        type: "button",
        small: true,
        onClick: onDone,
        disabled: !isValidSection,
        children: __('Done')
      }),
      children: getTooltipProps => /*#__PURE__*/_jsx(Tooltip, {
        ...getTooltipProps(),
        children: __('You need to complete this section')
      })
    }), /*#__PURE__*/_jsx(Button, {
      type: "button",
      kind: "ghost",
      onClick: onDelete,
      small: true,
      children: __('Delete section')
    })]
  });
};
export default SectionActions;